const navigationPl = {
    "menu_editor": "Menu",
    "settings": "Ustawienia",
    "payment_settings": "Ustawienia płatności",
    "user_management": "Zarządzanie użytkownikami",
    "logout": "Wyloguj",
    "subscription": "Prenumerata",
    "new_restaurant": "Utwórz nową restaurację",
    "privacy_policy": "Polityka prywatności",
    "terms_and_conditions": "Warunki korzystania z serwisu",
    "statistics": "Statystyka",
    "mozrest": "Menedżer recenzji",
    "signup": "Zapisać się"
};

export default navigationPl;
